"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectDropdown = void 0;
var _Icon = require("../Icon/Icon");
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _formsModule = _interopRequireDefault(require("@albelli/arc-3/lib/forms.module.css"));
var _dropdownModule = _interopRequireDefault(require("@albelli/arc-3/lib/dropdown.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SelectedValues = _ref => {
  let {
    values,
    allValues,
    onChange,
    ...props
  } = _ref;
  const onDelete = value => {
    var i = values.indexOf(value);
    if (i >= 0) {
      var newValues = values.concat([]).splice(0, i).concat(values.concat([]).splice(i + 1));
      onChange(newValues);
    }
  };
  const localise = value => {
    const definition = allValues.filter(x => x.value === value);
    return definition && definition[0] && definition[0].description || value;
  };
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: _dropdownModule.default["arc3-select-dropdown-selected-options"]
  }, props), values.map(value => {
    return /*#__PURE__*/_react.default.createElement(SelectedValue, {
      key: value,
      value: value,
      description: localise(value),
      onDelete: onDelete
    });
  }));
};
const SelectedValue = _ref2 => {
  let {
    value,
    description,
    onDelete
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _dropdownModule.default["arc3-select-dropdown-selected-option"]
  }, /*#__PURE__*/_react.default.createElement("small", null, description), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "arc3-pointer",
    size: "extra-small",
    name: "close",
    onClick: () => onDelete(value)
  }));
};
const UnselectedValues = _ref3 => {
  let {
    id,
    selectedValues,
    allValues,
    onChange,
    noOptionsLabel
  } = _ref3;
  const unselected = allValues.filter(x => !selectedValues.includes(x.value));
  const handleChange = e => {
    onChange === null || onChange === void 0 || onChange(selectedValues.concat([e.target.value]));
    e.target.selectedIndex = 0; //reset to the placeholder
  };
  return /*#__PURE__*/_react.default.createElement("select", {
    id: id,
    onChange: handleChange,
    value: ""
  }, /*#__PURE__*/_react.default.createElement(UnselectedPlaceholder, {
    show: unselected.length === 0,
    noOptionsLabel: noOptionsLabel
  }), unselected.map(item => {
    return /*#__PURE__*/_react.default.createElement("option", {
      key: item.value,
      value: item.value
    }, item.description);
  }));
};
const UnselectedPlaceholder = _ref4 => {
  let {
    show,
    noOptionsLabel
  } = _ref4;
  if (show) return /*#__PURE__*/_react.default.createElement("option", {
    className: "--no-options",
    value: "",
    disabled: true
  }, noOptionsLabel);
  return /*#__PURE__*/_react.default.createElement("option", {
    value: "",
    disabled: true
  });
};
const MultiSelectDropdown = _ref5 => {
  let {
    onChange,
    id,
    className,
    label,
    isRequired,
    error,
    selectedValues,
    allValues,
    noOptionsLabel,
    ...props
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    "data-cy": "arc3-multiselect-dropdown"
  }, !!label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "arc3-form-label"
  }, label, isRequired ? " *" : null), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_formsModule.default["arc3-form__input-wrapper"], "arc3-full-width", {
      error: !!error
    })
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_dropdownModule.default["arc3-select-dropdown"], _dropdownModule.default["--multi"])
  }, /*#__PURE__*/_react.default.createElement(SelectedValues, _extends({
    values: selectedValues,
    onChange: onChange,
    allValues: allValues
  }, props)), /*#__PURE__*/_react.default.createElement(UnselectedValues, {
    id: id,
    selectedValues: selectedValues,
    allValues: allValues,
    onChange: onChange,
    noOptionsLabel: noOptionsLabel || "No Options"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    name: "arrow_right",
    size: "extra-small",
    className: _dropdownModule.default["arc3-dropdown__icon"]
  })), /*#__PURE__*/_react.default.createElement("small", {
    className: _formsModule.default["arc3-form-message arc3-no-margin"]
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)({
      error: !!error
    }),
    style: {
      whiteSpace: "pre"
    }
  }, error || " "))));
};
exports.MultiSelectDropdown = MultiSelectDropdown;